import { GetClassificationsData } from '@/models/GetClassificationsData';
import { action } from 'typesafe-actions';
import { Classification, ClassificationsTypes } from './types';

export const getClassificationsRequest = (classificationData: GetClassificationsData) =>
    action(ClassificationsTypes.GET_CLASSIFICATIONS_REQUEST, classificationData);
export const getClassificationsSuccess = (listOfClassifications: Classification[]) =>
    action(ClassificationsTypes.GET_CLASSIFICATIONS_SUCCESS, listOfClassifications);
export const getClassificationsFailure = () => action(ClassificationsTypes.GET_CLASSIFICATIONS_FAILURE);
